import { render, staticRenderFns } from "./FeedbackComments.vue?vue&type=template&id=0fb8ff98&scoped=true"
import script from "./FeedbackComments.vue?vue&type=script&lang=ts"
export * from "./FeedbackComments.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackComments.vue?vue&type=style&index=0&id=0fb8ff98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8ff98",
  null
  
)

export default component.exports